module.exports = __webpack_public_path__ + "static/climate-c56cd09d2065f039e695121ba14b4a51.png";